// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const clocktower = defineModel({
  id: "clocktower",
  batchId: "future",
  name: "Clocktower",
  tags: ["building","clocktower","low-poly","age-of-mcp","future"],
  summary: "A clocktower keeping public time — order and civic pride.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.5,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(1, 0.14, 1), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(1, 0.14, 1), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.82, 0.8, 0.82), color: "#cdc3aa", position: [0, 0.54, 0] },
      { geometry: new THREE.BoxGeometry(0.88, 0.12, 0.88), color: "#a89d82", position: [0, 0.2, 0] },
      { geometry: new THREE.BoxGeometry(0.08, 0.8, 0.08), color: "#a89d82", position: [-0.41, 0.54, -0.41] },
      { geometry: new THREE.BoxGeometry(0.08, 0.8, 0.08), color: "#a89d82", position: [0.41, 0.54, -0.41] },
      { geometry: new THREE.BoxGeometry(0.08, 0.8, 0.08), color: "#a89d82", position: [-0.41, 0.54, 0.41] },
      { geometry: new THREE.BoxGeometry(0.08, 0.8, 0.08), color: "#a89d82", position: [0.41, 0.54, 0.41] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.3, 4), color: "#6b4a26", position: [-0.43, 0.65, -0.43] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.3, 4), color: "#6b4a26", position: [0.43, 0.65, -0.43] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.3, 4), color: "#6b4a26", position: [-0.43, 0.65, 0.43] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.3, 4), color: "#6b4a26", position: [0.43, 0.65, 0.43] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(1, 0.14, 1), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.82, 1.45, 0.82), color: "#cdc3aa", position: [0, 0.865, 0] },
      { geometry: new THREE.BoxGeometry(0.88, 0.12, 0.88), color: "#a89d82", position: [0, 0.2, 0] },
      { geometry: new THREE.BoxGeometry(0.08, 1.45, 0.08), color: "#a89d82", position: [-0.41, 0.865, -0.41] },
      { geometry: new THREE.BoxGeometry(0.08, 1.45, 0.08), color: "#a89d82", position: [0.41, 0.865, -0.41] },
      { geometry: new THREE.BoxGeometry(0.08, 1.45, 0.08), color: "#a89d82", position: [-0.41, 0.865, 0.41] },
      { geometry: new THREE.BoxGeometry(0.08, 1.45, 0.08), color: "#a89d82", position: [0.41, 0.865, 0.41] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.9, 4), color: "#6b4a26", position: [-0.43, 0.95, -0.43] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.9, 4), color: "#6b4a26", position: [0.43, 0.95, -0.43] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.9, 4), color: "#6b4a26", position: [-0.43, 0.95, 0.43] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.9, 4), color: "#6b4a26", position: [0.43, 0.95, 0.43] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(1, 0.14, 1), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.82, 1.9, 0.82), color: "#cdc3aa", position: [0, 1.09, 0] },
      { geometry: new THREE.BoxGeometry(0.88, 0.12, 0.88), color: "#a89d82", position: [0, 0.2, 0] },
      { geometry: new THREE.BoxGeometry(0.08, 1.9, 0.08), color: "#a89d82", position: [-0.41, 1.09, -0.41] },
      { geometry: new THREE.BoxGeometry(0.08, 1.9, 0.08), color: "#a89d82", position: [0.41, 1.09, -0.41] },
      { geometry: new THREE.BoxGeometry(0.08, 1.9, 0.08), color: "#a89d82", position: [-0.41, 1.09, 0.41] },
      { geometry: new THREE.BoxGeometry(0.08, 1.9, 0.08), color: "#a89d82", position: [0.41, 1.09, 0.41] },
      { geometry: new THREE.BoxGeometry(0.94, 0.08, 0.94), color: "#a89d82", position: [0, 2.08, 0] },
      { geometry: new THREE.ConeGeometry(1, 0.5, 4), color: "#4a5258", position: [0, 2.37, 0], rotation: [0, 0.785398, 0], scale: [0.735391, 1, 0.735391] },
      { geometry: new THREE.BoxGeometry(0.5, 0.26, 0.04), color: "#3c352c", position: [0, 1.54, 0.415] },
      { geometry: new THREE.CylinderGeometry(0.24, 0.24, 0.04, 14), color: "#caa64a", position: [0, 1.86, 0.42], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.2, 0.2, 0.03, 14), color: "#f3efe0", position: [0, 1.86, 0.44], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.03, 0.15, 0.01), color: "#2a2a2a", position: [0, 1.91, 0.46] },
      { geometry: new THREE.BoxGeometry(0.1, 0.03, 0.01), color: "#2a2a2a", position: [0.03, 1.86, 0.46] },
      { geometry: new THREE.BoxGeometry(0.3, 0.5, 0.05), color: "#4a3520", position: [0, 0.39, 0.42] },
    ] },
  ],
  animations: [],
});
